interface ButtonAuthProps {
  text: string;
  backgroundFilled: boolean;
  type?: "button" | "submit" | "reset";
}

const ButtonAuth = ({
  text,
  backgroundFilled,
  type = "button",
}: ButtonAuthProps) => {
  return (
    <button
      type={type}
      className={`font-inter w-full border rounded-sm border-main-black h-11 ${
        backgroundFilled
          ? "bg-main-black text-main-white hover:bg-light-black"
          : "bg-main-white text-main-black"
      }`}
    >
      {text}
    </button>
  );
};

export default ButtonAuth;
